import {
    IVR as PREFIX,
} from '../const';

const initialState = {
    list: [],
    loading: true,
    types: [],
};

const handlers = {
    ['SET_ITEMS_' + PREFIX]: (state, {payload: {list}}) => ({...state, list: list}),
    ['SET_LOADING_' + PREFIX]: (state, {payload}) => ({...state, loading: payload}),
    ['SET_TYPES_' + PREFIX]: (state, {payload: {types}}) => ({...state, types: types}),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
}